(function ($) {
  'use strict';

  const unfollow = (targetUserId, $button) => {
    const { followText, followIcon, followTitle } = $button.data();

    Thor.Relationship.delete(
      {},
      {
        qs: { followed_id: targetUserId }
      }
    ).then(() => {
      $button
        .removeClass('is-following')
        .data('is-following', false)
        .attr('data-is-following', false)
        .attr('data-original-title', followTitle)
        .attr('disabled', false)
        .html(followIcon + followText)
        .blur();
    });
  };

  const follow = (targetUserId, $button) => {
    const { unfollowText, unfollowIcon, unfollowTitle } = $button.data();

    Thor.Relationship.create(
      {},
      {
        data: { relationship: { followed_id: targetUserId } }
      }
    ).then(() => {
      $button
        .addClass('is-following')
        .data('is-following', true)
        .attr('data-is-following', true)
        .attr('data-original-title', unfollowTitle)
        .attr('disabled', false)
        .html(unfollowIcon + unfollowText)
        .blur();
    });
  };

  $(document)
    .off('click.relationships')
    .on('click.relationships', '.js-relationship', (event) => {
      if (!$('body').data().isUserSignedIn) {
        return;
      }

      const $button = $(event.currentTarget);
      let { targetUserId, isFollowing, loadingText } = $button.data();

      $button.attr('disabled', true);
      $button.html(loadingText);

      if (isFollowing) {
        unfollow(targetUserId, $button);
      } else {
        follow(targetUserId, $button);
      }
    });
})(jQuery);
